module.exports = __webpack_public_path__ + "img/history_btn.10dd48e1.png";